export default __webpack_public_path__ + "static/media/guia-2-1.7100c983.svg";